import { Power3 } from 'gsap'
import AnimatedComponent from './AnimatedComponent'

class VLine extends AnimatedComponent {
  buildTimelineIn () {
    const $el = this.$el
    this.timelineIn
      .fromTo(
        $el,
        0.6,
        { scaleY: 0 },
        { scaleY: 1, ease: Power3.easeInOut },
        0
      )
  }
}

export default VLine



// WEBPACK FOOTER //
// ./scripts/components/VLine.js